import { render, staticRenderFns } from "./trimHandleTopLeft.vue?vue&type=template&id=04b00296&"
import script from "./trimHandleTopLeft.vue?vue&type=script&lang=ts&"
export * from "./trimHandleTopLeft.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports